import { jsPDF } from "jspdf";

// Downloads a simple one-table report as an A4 PDF: a title, an optional subtitle line, and the
// table itself, repeating the header row on every page. Column widths are in mm and should add up
// to the usable page width (182mm on portrait A4 with the default margin).
export function downloadTablePdf({ fileName, title, subtitle, columns, rows }) {
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const margin = 14;
  const pageHeight = doc.internal.pageSize.getHeight();
  const rowHeight = 7;
  let y = margin;

  doc.setTextColor(23, 43, 69).setFont("helvetica", "bold").setFontSize(15);
  doc.text(title, margin, y + 4);
  y += 9;
  if (subtitle) {
    doc.setTextColor(96, 104, 116).setFont("helvetica", "normal").setFontSize(9);
    doc.text(subtitle, margin, y + 2);
    y += 7;
  }

  const cellX = (index) => margin + columns.slice(0, index).reduce((sum, column) => sum + column.width, 0);
  const drawCells = (values, options = {}) => {
    const tableWidth = columns.reduce((sum, column) => sum + column.width, 0);
    if (options.fill) {
      doc.setFillColor(...options.fill);
      doc.rect(margin, y, tableWidth, rowHeight, "F");
    }
    doc.setDrawColor(222, 226, 230).line(margin, y + rowHeight, margin + tableWidth, y + rowHeight);
    doc.setTextColor(...(options.color || [33, 37, 41]))
      .setFont("helvetica", options.bold ? "bold" : "normal")
      .setFontSize(9);
    values.forEach((value, index) => {
      const column = columns[index];
      const text = value == null ? "" : String(value);
      if (column.align === "right") {
        doc.text(text, cellX(index) + column.width - 2, y + 4.8, { align: "right" });
      } else {
        doc.text(text, cellX(index) + 2, y + 4.8);
      }
    });
    y += rowHeight;
  };
  const drawHeader = () => drawCells(columns.map((column) => column.label), { bold: true, fill: [233, 240, 250], color: [23, 43, 69] });

  drawHeader();
  rows.forEach((row, index) => {
    if (y + rowHeight > pageHeight - margin) {
      doc.addPage();
      y = margin;
      drawHeader();
    }
    drawCells(row, index % 2 ? { fill: [248, 249, 250] } : {});
  });

  doc.save(fileName);
}
